import * as React from "react"
import { createRoot } from "react-dom/client"
import { Provider } from "react-redux"

import { AppStore } from "../../store"
import OldUIContext from "../../olduicontext"
import { IOldUIContext } from "../../global"
import ScriptButton, { Props } from "./components/ScriptButton"

interface OldUIInit {
    startScriptButton: (elementSelector: string, props: Props) => void
}

function init(store: AppStore, oldUIContext: IOldUIContext): OldUIInit {
    const startScriptButton = (elementSelector: string, props: Props): void => {
        // we cannot pass down an element, because this is called from an iframe custom view
        // but the container we should load into is not within an iframe
        const element = document.querySelector(elementSelector)
        if (!element) {
            // target container doesn't exist, skip initialization
            return
        }

        const root = createRoot(element)
        root.render(
            <Provider store={store}>
                <OldUIContext.Provider value={oldUIContext}>
                    <ScriptButton {...props} />
                </OldUIContext.Provider>
            </Provider>,
        )
    }

    return {
        startScriptButton,
    }
}

export default init
